import React, { FC } from 'react'

interface Props {
  additionalClassNames?: string
  wrapperClassName?: string
}

const SpinnerWheel: FC<Props> = ({ additionalClassNames, wrapperClassName = 'spinner-wheel-wrap' }) => {
  return (
    <div className={wrapperClassName}>
      <span className={`spinner-wheel ${additionalClassNames}`}></span>
    </div>
  )
}

export default SpinnerWheel
